<a class="dh-brand" routerLink="/" aria-label="Drink Hopping, ir al inicio">
    <img class="dh-brand-mark" src="assets/favicon.png" alt="" width="36" height="36">
    <img class="dh-brand-word" src="assets/logo-largo.png" alt="Drink Hopping" height="20">
</a>
<span *ngIf="envName" class="dh-env-note" role="status">Entorno de {{ envName | lowercase }}</span>
<app-menu></app-menu>
